import React from "react";

const FaqsTitle = ({ children }) => (
  <h5 className="faqs__title-ppal mb-0'">{children}</h5>
);

export default FaqsTitle;
